export const calculatePercentageChange = (
  current: number,
  previous: number,
): { change: number; isPositive: boolean } => {
  if (previous === 0) {
    return {
      change: current === 0 ? 0 : 100, // Avoid divide by zero
      isPositive: current > 0,
    };
  }

  const change = ((current - previous) / Math.abs(previous)) * 100;
  return {
    change: parseInt(change.toFixed()),
    isPositive: change >= 0,
  };
};

export interface ProgressInputData {
  [key: string]: number;
}

interface ProgressItem {
  label: string;
  value: number;
  color: string;
}

interface ProgressMapping {
  [key: string]: { label: string; color: string };
}

export const transformToProgressData = (data: ProgressInputData, mapping: ProgressMapping): ProgressItem[] => {
  return Object.entries(mapping).map(([key, { label, color }]) => ({
    label,
    value: data[key] || 0,
    color,
  }));
};

export const STATUS_MAPPING = {
  failed: { label: "Failed", color: "#EF4444" },
  uploading: { label: "Pending Upload", color: "#F97316" },
  processing: { label: "Processing", color: "#2563EB" },
  completed: { label: "Successful", color: "#15803D" },
};

export const COMMENTS_MAPPING = {
  question: { label: "Questions", color: "#14B8A6" },
  feedback: { label: "Feedback", color: "#8B5CF6" },
  praise: { label: "Praise", color: "#3B82F6" },
  love: { label: "Love", color: "#F97316" },
};

export const DATE_FORMAT = "yyyy-MM-dd";

export const PAGE_SIZE = 10;

export const RBT_ANALYTICS_TITLES = {
  TOTAL_VIDEOS_RECORDED: "Total Videos Recorded",
  VIDEO_RECORDING_DURATION: "Total Video Recording Duration",
  AVG_VIDEO_UPLOAD_TIME: "Avg. Video Upload Time",
  AVG_RESPONSE_TIME_TO_BCBA_QUESTIONS: "Avg. Response Time to BCBAs Questions",
  AVG_RESPONSE_RATE_TO_BCBA_QUESTIONS: "Avg. Response Rate to BCBAs Questions",
  AVG_QUESTIONS_ASKED_PER_VIDEO: "Avg. Questions Asked per Video",
  AVG_COMMENT_RECEIVED_PER_VIDEO: "Avg. Comments Received per Video",
  TOTAL_COMMENTS_RECEIVED: "Total Comments Received",
} as const;

export const BCBA_ANALYTICS_TITLES = {
  AVG_VIDEOS_REVIEWED_PER_BCBA: "Avg. Videos Reviewed per BCBA",
  PERCENTAGE_VIDEOS_REVIEWED: "Percentage of Videos Reviewed",
  AVG_REVIEW_COMPLETION_TIME: "Avg. Review Completion Time",
  AVG_RESPONSE_TIME_TO_RBT: "Avg. Response Time to RBTs Questions",
  AVG_RESPONSE_RATE_TO_RBT: "Avg. Response Rate to RBTs Questions",
  AVG_COMMENTS_LEFT_PER_VIDEO: "Avg. Comments Left per Video",
  BREAKDOWN_OF_COMMENTS_LEFT: "Breakdown of Comments Left",
} as const;
